import React from 'react';

const InstancePageContext = React.createContext({});
export default InstancePageContext;
